<template>
  <div class='h-outTabs'>
    <ejs-tab id='observeTaskTab' ref='tabRef' :showCloseButton='true' :removing='changeTab' :removed='removeTabFunc' :selecting='tabSelect'　heightAdjustMode='Auto'>
      <e-tabitems>
        <e-tabitem :header='tab.headerText' content='#observeTable' cssClass='h-tab-noClose'></e-tabitem>
      </e-tabitems>
    </ejs-tab>
    <div id='observeTable' class='h100vh-140'>
      <ObserveTableMenu @methodEnum='methodEnum' @keywords='changeKeywords'></ObserveTableMenu>
      <ObserveTable :observeType='observeType' ref="observeTable" @addTab='addTab' @downloadTab='downloadTab'></ObserveTable>
    </div>
  </div>
</template>
<script>
import ObserveTableMenu from './ObserveTableMenu';
import ObserveTable from './ObserveTable';
import ImportObserveList from '../importObserve/ImportObserveList';
import DownloadFile from './DownloadFile';
import bus from '../bus.js';
import { EventBus } from '../../../plugins/eventBus';
import socketInstance from '../../../plugins/stompSock';

export default {
  name: 'ObserveTaskList',
  components: {
    ObserveTableMenu,
    ObserveTable
  },
  props: ['observeType'],
  data() {
    return {
      locale: localStorage.getItem('locale'),
      tab: {
        headerText: { text: this.$t('Observe.taskList') }
      },
      tabList: [this.$t('Observe.taskList')],
      tabListVallue: [this.$t('Observe.taskList')]
    };
  },
  methods: {
    tabSelect(e) {
      if (e.isSwiped) {
        e.cancel = true;
      }
    },
    changeKeywords(args) {
      this.$refs.observeTable.queryConditions.keywords = args;
      this.$refs.observeTable.page.pageNo = "1";
      this.$refs.observeTable.getObserveListData();
    },
    addTab(args) {
      // 在父窗口增加一个TAB页
      const title = args[0].taskName;
      const item = {
        header: { text: title },
        content() {
          return {
            template: ImportObserveList
          };
        }
      };
      localStorage.setItem('observeNowTab', JSON.stringify({
        name: title,
        value: args,
        type: 'missionTab'
      }));
      this.addTabFunc(title, item, args);
    },
    downloadTab(args) {
      const title = this.$t('Observe.download');
      const item = {
        header: { text: title },
        content() {
          return {
            template: DownloadFile
          };
        }
      };
      this.addTabFunc(title, item, args);
    },
    downloadObserveTableTab(args) {
      const title = args[0].fileName;
      const item = {
        header: { text: title },
        content() {
          return {
            template: ImportObserveList
          };
        }
      };
      localStorage.setItem('observeNowTab', JSON.stringify({
        name: title,
        value: args,
        type: 'Import'
      }));
      this.addTabFunc(title, item, args);
    },
    addTabFunc(title, item, args) {
      const tabObj = this.$refs.tabRef.ej2Instances;
      const itemLength = document.querySelectorAll('#observeTaskTab .e-tab-header .e-toolbar-item').length;
      const index = this.tabList.findIndex(v => v === title);
      if (index > 0) {
        tabObj.select(index);
      } else if (title !== this.$t('Observe.download') && title.indexOf('.json') === -1) {
        const missionTab = this.tabList.filter(v => v !== this.$t('Observe.download') && v.indexOf('.json') === -1);
        if (missionTab.length > 5) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Observe.maximumMissionNumber')});
        } else {
          this.tabList.push(title);
          this.tabListVallue.push(args);
          tabObj.addTab([item], itemLength);
          tabObj.select(itemLength);
        }
      } else {
        this.tabList.push(title);
        this.tabListVallue.push(args);
        tabObj.addTab([item], itemLength);
        tabObj.select(itemLength);
      }
      bus.$emit(title, args);
    },
    removeTabFunc(args) {
      const index = this.tabList.findIndex(v => v === args.removedItem.textContent);
      bus.$off(this.tabList[index]);
      if (this.tabList[index] !== this.$t('Observe.download') && this.tabList[index].indexOf('.json') === -1) {
        // 只有跟踪页面关闭websocket
        socketInstance.stopReceiveTopicMsg(`observe_${this.tabListVallue[index][0].taskId}`, '/user/#/ObserveReportServer');
      }
      this.tabList.splice(index, 1);
      this.tabListVallue.splice(index, 1);
    },
    changeTab(args) {
      const index = this.tabList.findIndex(v => v === args.removedItem.textContent);
      const tabObj = this.$refs.tabRef.ej2Instances;
      const selecteIdndex = tabObj.selectedItem;
      const itemLength = document.querySelectorAll('#observeTaskTab .e-tab-header .e-toolbar-item').length;
      if (index == selecteIdndex) {
        if (index == (itemLength - 1)) {
          tabObj.select(itemLength - 2);
        } else {
          tabObj.select(itemLength - 1);
        }
      }
    },
    methodEnum(opcode) {
      switch (opcode) {
        case 'refresh':
          this.$refs.observeTable.queryConditions.keywords = '';
          this.$refs.observeTable.page.pageNo = "1";
          this.$refs.observeTable.getObserveListData();
          break;
        case 'add':
          this.$refs.observeTable.addObservePage();
          break;
        case 'active':
          this.$refs.observeTable.activeObservePage();
          break;
        case 'hangup':
          this.$refs.observeTable.hangupObservePage();
          break;
        case 'finish':
          this.$refs.observeTable.finishObservePage();
          break;
        case 'delete':
          this.$refs.observeTable.deleteObservePage();
          break;
        case 'detail':
          this.$refs.observeTable.detailObservePage();
          break;
        case 'mission':
          this.$refs.observeTable.missionObservePage();
          break;
        case 'download':
          this.$refs.observeTable.downloadObservePage();
          break;
        default:
      }
    }
  },
  mounted() {
    bus.$on('downloadObserveTableTab', (args) => {
      console.log(1, args);
      this.downloadObserveTableTab(args);
    });
  },
  beforeDestroy() {
    bus.$off('downloadObserveTableTab');
  }
};
</script>
